
export default {
  name: "Search",
  emits: ["update:input"],
  props: {
    input: {
      type: String,
    }
  }
}
